/* eslint-disable no-underscore-dangle */
import { Directive, HostBinding, Inject, Input, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { AccordionDirective } from './accordion.directive';

@Directive({
    selector: '[appAccordionLink]',
    standalone: false
})
export class AccordionLinkDirective implements OnInit, OnDestroy {

  @Input() public group: any;

  // Manual toggle state (fallback when URL doesn't match this group).
  protected _open = false;
  protected nav: AccordionDirective;

  public constructor(
    @Inject(AccordionDirective) nav: AccordionDirective,
    private router: Router
  ) {
    this.nav = nav;
  }

  /**
   * True when the current URL contains this section's route segment.
   * Re-evaluated on every change-detection cycle — no subscriptions needed.
   */
  private get isActiveUrl(): boolean {
    if (!this.group) { return false; }
    const segments = this.router.url.split('/');
    return segments.indexOf(String(this.group)) > 0;
  }

  @HostBinding('class.open')
  @Input()
  get open(): boolean {
    if (this.group) {
      // Open when the URL matches (persists through navigation) OR
      // when the user manually expanded this section (_open).
      return this.isActiveUrl || this._open;
    }
    return this._open;
  }

  set open(value: boolean) {
    this._open = value;
    if (value) {
      this.nav.closeOtherLinks(this);
    }
  }

  public ngOnInit(): any {
    this.nav.addLink(this);
  }

  public ngOnDestroy(): any {
    this.nav.removeGroup(this);
  }

  public toggle(): any {
    this.open = !this.open;
  }
}
